import styled from 'styled-components';

export const BookingsContainer = styled.div`
  background: linear-gradient(to bottom, #8eaef7, #6f6bf0);
  border-radius: 5px;
  box-sizing: border-box;
  box-shadow: 0 0 1px 0 rgba(50, 50, 50, 1);
  color: var(--text-light-color);
  margin: 0 1em 1em;
  padding: 2em;
`;

export const BookingListWrapper = styled.ul`
  margin: 0 0 1em;
  padding: 0;
`;

export const BookingElement = styled.li`
  display: flex;
  align-items: center;
  padding: 0.5em 0;
`;

export const BookingListElement = styled.div`
  font-size: 0.9em;
  font-weight: 200;
  line-height: 1.4;
  margin-left: 1em;
`;

export const H4 = styled.h4`
  font-size: 1em;
  font-weight: 600;
  margin: 0 0 0.5em;
`;

export const H3 = styled.h3`
  font-weight: 600;
  margin: 0 0 0.5em;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: stretch;
`;

export const BookingButton = styled.button`
  flex: 1 0 50%;
  padding: 1em;

  background-color: transparent;
  border: 1px solid var(--text-light-color);
  border-radius: 5px;
  color: var(--text-light-color);
  cursor: pointer;
  outline: none;
  font-size: 0.9em;
  text-align: center;

  & + & {
    margin-left: 1em;
  }
`;
